import * as React from "react";
import ReactHtmlParser from 'react-html-parser';

export interface CTABlockProps {
  formFieldDefinition: any;
}

export class CTABlock extends React.Component<CTABlockProps> {
  constructor(props: CTABlockProps) {
    super(props);
  }

  render() {
    return <div className="form-cta-block">
      <h2>{this.props.formFieldDefinition.ctaTitle}</h2>
      <p>{ReactHtmlParser(this.props.formFieldDefinition.ctaDescription)}</p>
      <a href={this.props.formFieldDefinition.ctaButtonLink} 
        className="btn btn-success">{this.props.formFieldDefinition.ctaButtonText}</a>
  </div>;
  }
}